import { Autocomplete } from '@mui/lab';
import TextField from '@mui/material/TextField/TextField';
import React from 'react';
// import moment from 'moment-timezone';

// const formatTimezone = (datetime) => {
//     const offsetInMinutes = moment.tz(datetime).utcOffset();
//     const offsetInHours = Math.abs(offsetInMinutes / 60);
//     const offsetSign = offsetInMinutes < 0 ? '-' : '+';
//     const offset = `GMT${offsetSign}${offsetInHours.toString().padStart(2, '0')}:00`;
//     return `${datetime} ${offset}`
// }

const TimezonesInput = ({ handleTimeZoneChange, localTimezone }) => {
    const timezones = Intl.supportedValuesOf('timeZone')
    // const timezones = [];

    // const timezones = moment.tz.names().map((timezone) => {
    //     const offset = moment.tz(timezone).format('Z');
    //     return `${timezone} GMT${offset}`;
    // });

    // for (const tz of moment.tz.names()) {
    //     let res = formatTimezone(tz)
    //     timezones.push(res)
    // }
    // const localTimezone = moment.tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('Z');

    // const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const [newTimeZone, setNewTimezone] = React.useState(localTimezone);
    const handleChange = (newValue) => {
        setNewTimezone(newValue)
        handleTimeZoneChange(newValue)
    }

    return (
        <Autocomplete
            value={newTimeZone}
            onChange={(_, newValue) => {
                handleChange(newValue);
            }}
            disablePortal
            options={timezones}
            defaultValue={timezones[0]}
            renderInput={(params) => (
                <TextField required {...params} label="Select timezone" size="small" />
            )}
        />
    );
};

export default TimezonesInput;